/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_A3Inputs */

const en_directory_home_faq_a3 = /** @type {(inputs: Directory_Home_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Submit, paste your product link, add a short pitch with its category and pricing, and our editors review it before it goes live.`)
};

const zh_directory_home_faq_a3 = /** @type {(inputs: Directory_Home_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开提交页，粘贴产品链接，补充一段简短介绍并选择分类和定价方式，编辑审核通过后即可上线。`)
};

/**
* | output |
* | --- |
* | "Open Submit, paste your product link, add a short pitch with its category and pricing, and our editors review it before it goes live." |
*
* @param {Directory_Home_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_a3 = /** @type {((inputs?: Directory_Home_Faq_A3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_A3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_a3(inputs)
	return zh_directory_home_faq_a3(inputs)
});
export { directory_home_faq_a3 as "directory.home.faq.a3" }